module.exports = __webpack_public_path__ + "img/orders.458a729b.svg";